import { c as _c } from "react/compiler-runtime";
import { SkeletonBar } from '@petsmart-ui/sparky';
import './FeedbackSkeletonV2.scss';
export function FeedbackSkeletonV2() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="feedback-skeleton-v2"><SkeletonBar aria-hidden="true" className="feedback-skeleton-v2__text" /><SkeletonBar aria-hidden="true" className="feedback-skeleton-v2__button" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}